// extracted by mini-css-extract-plugin
module.exports = {"Avatar":"Avatar_Avatar__QctBv","AvatarInitials":"Avatar_AvatarInitials__2eIwB"};